import { Component, OnInit } from '@angular/core';
import {
  Platform,
  MenuController,
  NavController,
  ModalController,
  AlertController,
} from '@ionic/angular';

import { SocialiconPage } from './modals/socialicon/socialicon.page';
import { ApiService } from './services/api.service';
import { UtilserviceService } from './services/utilservice.service';
import { AuthenticationService } from './services/authentication.service';

import { jhcassoAPIUri } from 'src/environments/apiUri';
import { ProfileData, ProfileInfoResponse } from './models/Response/ProfileResponse';
import { GeoLocationService } from './services/geo-location-service.service';
import { ApplocalstorageService } from './services/applocalstorage.service';
import { TranslateService } from '@ngx-translate/core';

// Capacitor
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Network } from '@capacitor/network';
import { App } from '@capacitor/app';

declare const window: any;
import { Router } from '@angular/router';
import OneSignal from 'onesignal-cordova-plugin';
import { CacheService } from './services/cache.service';
import { ProfileService } from './services/profile.service';
import { NavigationService } from './services/navigation.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {

  DATA: any;
  isLoggedIn = false;

  option: any = { header: 'Language' };
  languages = localStorage.getItem('lan') ?? 'en';
  token = String(localStorage.getItem('token') ?? '');
  xtoken: string;
  private oneSignalInitialized = false;
  public oneSignalReady: Promise<void>;
  private resolveOneSignalReady: () => void;

  constructor(
    private platform: Platform,
    private alertCtrl: AlertController,
    private translate: TranslateService,
    public geoLocationService: GeoLocationService,
    private localStorageService: ApplocalstorageService,
    private menu: MenuController,
    private navCtrl: NavController,
    private modal: ModalController,
    private api: ApiService,
    private util: UtilserviceService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private cache: CacheService,
    private profileService: ProfileService,
    private nav: NavigationService
  ) {
    this.initializeApp();

    const lan = localStorage.getItem('lan') ?? 'en';


    this.translate.setDefaultLang(lan);
    this.translate.use(lan);

    this.translate.get('SelectLanguage.label').subscribe(text => {
      this.option.header = text;
    });

    localStorage.setItem('lan', lan);
    document.documentElement.dir = 'ltr';

    this.checkNetworkOnStart(lan);
    
    //this.nav.home();

    if (this.api.isLoggedIn()) {
      this.profileService.loadProfile();
      this.api.get(jhcassoAPIUri.profile).subscribe(
        (res: ProfileInfoResponse) => {
          if (res.status) {
            this.DATA = res.data?.address?.[0]?.addressId ?? null;
          }
          
        },
        err => {
          console.error('profile fetch error', err);
          
        }
      );
    }

    this.isLoggedIn = this.api.isLoggedIn();

    this.oneSignalReady = new Promise(resolve => {
      this.resolveOneSignalReady = resolve;
    });
  }

  ngOnInit() {
    try {
      if (window?.cache) {
        window.cache.clear?.(() => { }, () => { });
        window.cache.cleartemp?.();
      }
    } catch {
      // ignore
    }
  }

  async initializeApp() {

    this.platform.ready().then(() => {

      // Existing logic (status bar, splash etc.) yaha rahe
      this.api.get(jhcassoAPIUri.settings).subscribe((response: any) => {
        if (response.status) {
          localStorage.setItem("currency_symbol", response.data.currencySymbol);
          localStorage.setItem("lat", response.data.lat);
          localStorage.setItem("lang", response.data.lang);
          localStorage.setItem("appSettingInfo", JSON.stringify(response.data));
          //this.util.setAppSettingInfo(response.data);

          this.initializeOneSignal(response.data);

          // this.oneSignal.startInit(
          //   response.data.ownerAppId,
          //   response.data.projectNo
          // );
          // this.oneSignal.getIds().then((token) => {
          //   localStorage.setItem("pushToken", token.userId);
          //   localStorage.setItem("deviceToken", token.userId);
          // });
          // this.oneSignal.endInit();
          // this.excuteOneSignalToGetToken(ownerAppId,projectNo);
        }
      });


    });

    if (this.platform.is('android')) {
      localStorage.setItem('platform', 'android');
      try {
        // // // // alert('Checking location permission on start');
        await this.geoLocationService.checkLocationPermission();
      } catch { }
    } else {
      localStorage.setItem('platform', 'ios');
    }

    this.setupNetworkListeners();

    try {
      await StatusBar.setStyle({ style: Style.Dark });
      await StatusBar.setBackgroundColor({ color: '#E06287' });
    } catch { }

    setTimeout(async () => {
      try {
        await SplashScreen.hide();
      } catch { }
    }, 1000);

    setTimeout(() => {
      try {
        this.localStorageService.callAppSettingInfo();
      } catch { }
    }, 2000);

    App.addListener('backButton', () => {
      const path = window.location?.pathname ?? '';
      if (path === '/home' || path === '/home/') {
        this.exitApp();
      } else {
        this.navCtrl.back();
      }
    });
  }

  async initializeOneSignal(response: any) {

    console.log('Initializing OneSignal...');

    if (!this.platform.is('android') || !window?.cordova) {
      console.log("Skipping OneSignal - Not running on real device");
      return;
    }

    // 🔐 Prevent multiple initialization
    if (this.oneSignalInitialized) {
      console.log("OneSignal already initialized");
      return;
    }

    try {

      // ✅ Initialize SDK
      await OneSignal.initialize("a4d80f6c-5d74-4536-96cd-fa2406dc3d0f");

      // ✅ Request permission (Android 13+ safe)
      await OneSignal.Notifications.requestPermission(true);

      // ✅ Foreground Notification
      OneSignal.Notifications.addEventListener('foregroundWillDisplay', (event: any) => {
        console.log('Notification received:', event);

        event.preventDefault();
        event.notification.display();
      });

      // ✅ Notification Click
      OneSignal.Notifications.addEventListener('click', (event: any) => {
        console.log('Notification opened:', event);

        const page = event.notification?.additionalData?.page;
        if (page) {
          this.router.navigate([page]);
        }
      });

      // 🔥 WAIT until subscription becomes active
      OneSignal.User.pushSubscription.addEventListener("change", (event: any) => {

        const deviceId = event.current?.id;

        if (deviceId) {

          console.log("OneSignal Device ID Ready:", deviceId);

          // Store locally
          localStorage.setItem("deviceToken", deviceId);

          // Resolve only once
          if (this.resolveOneSignalReady) {
            this.resolveOneSignalReady();
            this.resolveOneSignalReady = null;
          }

        } else {
          console.log("Push subscription not ready yet");
        }

      });

      this.oneSignalInitialized = true;

    } catch (err) {
      console.error("OneSignal Initialization Error:", err);
    }
  }

  setupNetworkListeners() {
    Network.addListener('networkStatusChange', status => {
      if (!status.connected) {
        this.handleNetworkDisconnect();
      }
    });
  }

  async handleNetworkDisconnect() {
    const alert = await this.alertCtrl.create({
      header: 'Check Network Connection',
      message: 'You do not have an internet connection.',
      buttons: [{ text: 'OK', handler: () => this.exitApp() }],
    });
    await alert.present();
  }

  private checkNetworkOnStart(lan: string) {
    Network.getStatus().then(status => {
      if (!status.connected) {
        this.util.presentToast(
          'Network was disconnected :-('
        );
      }
    });
  }

  private exitApp() {
    App.exitApp();
  }

  async presentModal() {
    this.menu.close();
    const modal = await this.modal.create({
      component: SocialiconPage,
      cssClass: 'social-icon',
    });
    return modal.present();
  }

  async Logout() {
    const alert = await this.alertCtrl.create({
      header: "Confirm Logout",
      message: "Are you sure you want to logout?",
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: "secondary",
        },
        {
          text: "Logout",
          handler: () => {
            this.api
              .post(jhcassoAPIUri.logout, null)
              .subscribe((response: any) => {
                // this.googlePlus.disconnect();
                // this.googlePlus.logout();
                this.authenticationService.logout();

                // Clear token and update state
                localStorage.removeItem("xtoken");
                this.xtoken = "";
                this.api.newLogin.next(true);

                // Navigate to login page or update the view as needed
                this.navCtrl.navigateRoot("login-signup");
              });
          },
        },
      ],
    });

    await alert.present();
  }
}
